{
  "common": {
    "loading": "Chargement...",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "delete": "Supprimer",
    "edit": "Modifier",
    "create": "Creer",
    "search": "Rechercher",
    "filter": "Filtrer",
    "actions": "Actions",
    "status": "Statut",
    "noResults": "Aucun resultat",
    "previous": "Precedent",
    "next": "Suivant",
    "yes": "Oui",
    "no": "Non",
    "success": "Operation reussie",
    "error": "Une erreur est survenue",
    "id": "ID",
    "date": "Date",
    "back": "Retour",
    "retry": "Réessayer",
    "all": "Tous",
    "close": "Fermer",
    "loadMore": "Charger plus",
    "showingRange": "Affichage {{start}}-{{end}} sur {{total}}",
    "rowsPerPage": "Lignes par page",
    "totalResults": "{{total}} resultat(s)",
    "loadError": "Impossible de charger les donnees.",
    "viewDetail": "Voir le detail"
  },
  "header": {
    "searchPlaceholder": "Rechercher utilisateurs, commandes, articles..."
  },
  "auth": {
    "login": "Se connecter",
    "logout": "Se deconnecter",
    "email": "Adresse email",
    "otpCode": "Code de verification",
    "sendCode": "Envoyer le code",
    "verifyCode": "Verifier",
    "notAdmin": "Ce compte ne dispose pas des privileges administrateur.",
    "sessionExpired": "Votre session a expire. Veuillez vous reconnecter.",
    "codeSentTo": "Code envoye a",
    "unavailable": {
      "title": "Service momentanement indisponible",
      "message": "Impossible de verifier votre session pour le moment. Vous n'avez pas ete deconnecte.",
      "retry": "Reessayer"
    },
    "errors": {
      "failedToSendCode": "Impossible d'envoyer le code de verification",
      "notFullyRegistered": "Ce compte n'est pas entierement enregistre.",
      "invalidCode": "Code de verification invalide",
      "emailRequired": "Saisissez une adresse email.",
      "otpRequired": "Saisissez le code de verification."
    }
  },
  "nav": {
    "platformWallet": "Wallet Blisterr",
    "dashboard": "Tableau de bord",
    "general": "General",
    "catalog": "Catalogue",
    "moderation": "Moderation",
    "reports": "Signalements",
    "reviews": "Avis",
    "messaging": "Messagerie",
    "peeks": "Articles",
    "shops": "Boutiques",
    "users": "Utilisateurs",
    "sellerRequests": "Demandes vendeur",
    "finance": "Finance",
    "buyerStrikes": "Penalites acheteur",
    "sellerDebts": "Dettes vendeurs",
    "missingInvoices": "Factures manquantes",
    "pdpSubmissionReviews": "Revues PDP",
    "commerce": "Commerce",
    "orders": "Commandes",
    "lives": "Lives",
    "discounts": "Reductions",
    "referralCampaigns": "Campagnes parrainage",
    "configuration": "Configuration",
    "categories": "Categories",
    "deliveryCarriers": "Transporteurs",
    "shippingRates": "Tarifs d'expedition",
    "search": "Recherche",
    "system": "Systeme",
    "reconciliation": "Reconciliation",
    "queues": "Files d'attente",
    "adminActions": "Actions admin",
    "systemHealth": "Sante systeme",
    "launchStatus": "Statut de lancement",
    "nodes": "Noeuds",
    "infrastructure": "Infrastructure",
    "emails": "Templates Email",
    "notificationDeliveries": "Livraisons notifications",
    "reference": "Referentiel",
    "referenceTcg": "TCG",
    "referenceIngestion": "Ingestion",
    "personal": "Mon compte",
    "settings": "Reglages",
    "productRequests": "Demandes produit",
    "support": "Support",
    "supportTickets": "Tickets de support"
  },
  "dashboard": {
    "title": "Tableau de bord",
    "totalUsers": "Utilisateurs",
    "totalSellers": "Vendeurs",
    "activeLives": "Lives actifs",
    "totalOrders": "Commandes",
    "revenue": "Frais encaissés nets",
    "pendingModeration": "En attente de moderation",
    "pendingReports": "Signalements en attente",
    "pendingSellerRequests": "Demandes vendeur en attente",
    "newUsersToday": "Nouveaux aujourd'hui",
    "newUsersThisWeek": "Nouveaux cette semaine",
    "ordersToday": "Commandes aujourd'hui",
    "revenueToday": "Revenus aujourd'hui",
    "itemsOnSale": "Articles en vente",
    "itemsSold": "Articles vendus",
    "itemsDraft": "Brouillons",
    "attentionRequired": "Actions requises",
    "quickActions": "Actions rapides",
    "secondaryStats": "Statistiques detaillees",
    "reviewReports": "Examiner les signalements",
    "reviewSellerRequests": "Examiner les demandes",
    "runReconciliation": "Lancer la reconciliation",
    "createDiscount": "Creer une reduction",
    "attentionReports": "{{count}} signalement(s) en attente",
    "attentionSellerRequests": "{{count}} demande(s) vendeur en attente",
    "attentionStrikes": "{{count}} strike(s) acheteur actif(s)",
    "attentionSellerDebts": "{{count}} dette(s) vendeur en souffrance",
    "attentionReconciliation": "{{count}} reconciliation(s) en echec",
    "attentionMissingInvoices": "{{count}} facture(s) manquante(s)",
    "loadError": "Impossible de charger les donnees du tableau de bord"
  },
  "reports": {
    "title": "Signalements",
    "detail": "Detail du signalement",
    "targetType": "Type de cible",
    "reason": "Raison",
    "reporter": "Signaleur",
    "review": "Examiner",
    "resolve": "Resoudre",
    "dismiss": "Rejeter",
    "resolveDialogTitle": "Resoudre le signalement",
    "resolveDialogMessage": "Etes-vous sur de vouloir marquer ce signalement comme resolu ? Cette action confirme que le signalement a ete traite.",
    "resolveReasonPlaceholder": "Expliquez comment ce signalement a ete traite (requis)",
    "dismissDialogTitle": "Rejeter le signalement",
    "dismissDialogMessage": "Etes-vous sur de vouloir rejeter ce signalement ? Cela indique qu'aucune action supplementaire n'est necessaire.",
    "filterByStatus": "Filtrer par statut",
    "tabs": {
      "byContent": "Par contenu signale",
      "byReport": "Par signalement"
    },
    "status": {
      "PENDING": "En attente",
      "REVIEWING": "En cours d'examen",
      "RESOLVED": "Resolu",
      "DISMISSED": "Rejete"
    },
    "toast": {
      "reviewing": "Signalement passe en cours d'examen",
      "resolved": "Signalement marque comme resolu",
      "dismissed": "Signalement rejete"
    }
  },
  "reviews": {
    "title": "Avis",
    "hide": "Masquer",
    "reject": "Rejeter",
    "republish": "Republier",
    "rating": "Note",
    "reviewer": "Auteur",
    "confirmHide": "Etes-vous sur de vouloir masquer cet avis ?",
    "confirmReject": "Etes-vous sur de vouloir rejeter cet avis ? L'auteur sera notifie.",
    "confirmRepublish": "Etes-vous sur de vouloir republier cet avis ?",
    "hiddenSuccess": "Avis masque",
    "rejectedSuccess": "Avis rejete",
    "republishedSuccess": "Avis republie",
    "status": {
      "PUBLISHED": "Publie",
      "HIDDEN": "Masque",
      "REJECTED": "Rejete"
    }
  },
  "items": {
    "title": "Articles",
    "detail": "Detail de l'article",
    "searchPlaceholder": "Rechercher par nom ou vendeur...",
    "itemsFound": "{{count}} article(s) trouve(s)",
    "allStatuses": "Tous les statuts",
    "allTypes": "Tous les types",
    "allModeration": "Toute moderation",
    "allContexts": "Tous les contextes",
    "flag": "Signaler",
    "clear": "Retirer le signalement",
    "seller": "Vendeur",
    "shop": "Boutique",
    "price": "Prix",
    "flagReason": "Raison du signalement",
    "flagReasonPlaceholder": "Saisissez la raison du signalement...",
    "generalInfo": "Informations generales",
    "description": "Description",
    "condition": "Etat",
    "category": "Categorie",
    "country": "Pays",
    "weight": "Poids",
    "quantity": "Quantite",
    "followers": "Abonnes",
    "createdAt": "Date de creation",
    "soldDate": "Date de vente",
    "pricing": "Tarification",
    "startDate": "Date de debut",
    "endDate": "Date de fin",
    "audience": "Audience",
    "startingPrice": "Prix de depart",
    "currentPrice": "Prix actuel",
    "duration": "Duree",
    "auctionType": "Type d'enchere",
    "bidCount": "Encheres",
    "liveId": "Live",
    "participants": "Participants",
    "media": "Medias",
    "noImages": "Aucune image",
    "video": "Video",
    "moderationSection": "Moderation",
    "moderationStatus": "Statut de moderation",
    "moderationReason": "Raison",
    "moderatedBy": "Modere par",
    "moderatedAt": "Modere le",
    "context": "Contexte",
    "peek": "Peek",
    "live": "Live",
    "status": {
      "DRAFT": "Brouillon",
      "SCHEDULED": "Planifie",
      "ON_SALES": "En vente",
      "RESERVED": "Reserve",
      "SOLD": "Vendu",
      "UNSOLD": "Invendu",
      "ARCHIVED": "Archive",
      "DELETED": "Supprime"
    },
    "type": {
      "FIXED_PRICE": "Prix fixe",
      "AUCTION": "Enchere",
      "GIVEAWAY": "Giveaway"
    },
    "moderation": {
      "FLAGGED": "Signale",
      "CLEARED": "Approuve",
      "NONE": "Aucune"
    },
    "unpublish": "Retirer",
    "forceDelete": "Supprimer definitivement",
    "republish": "Republier",
    "editItem": "Modifier l'article",
    "unpublishConfirmTitle": "Retirer l'article",
    "unpublishConfirmMessage": "Cela retirera l'article \"{{title}}\" de la marketplace. Le vendeur sera notifie.",
    "forceDeleteConfirmTitle": "Supprimer definitivement",
    "forceDeleteConfirmMessage": "Cela supprimera DEFINITIVEMENT l'article \"{{title}}\". Cette action est irreversible.",
    "republishConfirmTitle": "Republier l'article",
    "republishConfirmMessage": "Cela remettra l'article \"{{title}}\" en vente sur la marketplace.",
    "editSuccess": "Article mis a jour",
    "unpublishSuccess": "Article retire",
    "forceDeleteSuccess": "Article supprime",
    "republishSuccess": "Article republie",
    "endAuction": "Terminer l'enchere",
    "endAuctionConfirmTitle": "Terminer l'enchere",
    "endAuctionConfirmMessage": "Cette action va terminer l'enchere immediatement. Le dernier encherisseur sera declare gagnant. Cette action est irreversible.",
    "endAuctionSuccess": "Enchere terminee",
    "drawGiveaway": "Tirer au sort",
    "drawGiveawayConfirmTitle": "Tirer au sort le gagnant",
    "drawGiveawayConfirmMessage": "Cette action va tirer au sort un gagnant parmi les participants du giveaway. Cette action est irreversible.",
    "drawGiveawaySuccess": "Tirage au sort effectue",
    "launchItem": "Lancer maintenant",
    "launchItemTitle": "Lancer la vente maintenant",
    "launchItemMessage": "Cette action va lancer immediatement la vente de cet article, sans attendre la date programmee. Cette action est irreversible.",
    "launchItemSuccess": "Vente lancee avec succes",
    "launchItemError": "Impossible de lancer la vente",
    "scheduledJobs": "Jobs programmes",
    "scheduledAuctionEnd": "Fin enchere programmee",
    "scheduledGiveawayDraw": "Tirage programme",
    "scheduledSaleStart": "Lancement vente programme",
    "noScheduledJobs": "Aucun job programme",
    "videoSection": "Video",
    "videoUrl": "URL de la video",
    "videoId": "ID de la video",
    "videoStatus": "Statut de traitement",
    "videoStatusReady": "Pret",
    "videoStatusProcessing": "En cours de traitement",
    "videoStatusNone": "Aucune video",
    "openVideo": "Ouvrir la video",
    "emptyFilterTitle": "Aucun article ne correspond a vos filtres",
    "emptyFilterDescription": "Essayez d'ajuster ou de reinitialiser les filtres pour voir tous les articles.",
    "clearFilters": "Reinitialiser les filtres"
  },
  "users": {
    "title": "Gestion des utilisateurs",
    "searchPlaceholder": "Rechercher par nom, email ou telephone...",
    "allStatuses": "Tous les statuts",
    "allRoles": "Tous les roles",
    "usersFound": "utilisateur(s) trouve(s)",
    "accountInfo": "Informations du compte",
    "address": "Adresse",
    "street": "Rue",
    "city": "Ville",
    "zipCode": "Code postal",
    "country": "Pays",
    "shop": "Boutique",
    "shopName": "Nom de la boutique",
    "shopId": "ID boutique",
    "wallet": "Portefeuille",
    "balance": "Solde",
    "actions": "Actions",
    "suspend": "Suspendre",
    "ban": "Bannir",
    "reactivate": "Reactiver",
    "confirmSuspend": "Etes-vous sur de vouloir suspendre cet utilisateur ?",
    "confirmBan": "Etes-vous sur de vouloir bannir cet utilisateur ? Cette action est irreversible.",
    "confirmReactivate": "Etes-vous sur de vouloir reactiver cet utilisateur ?",
    "banMessaging": "Bannir de la messagerie",
    "confirmBanMessaging": "Etes-vous sur de vouloir empecher cet utilisateur d'envoyer des messages ? Il ne pourra plus envoyer de messages prives ni de messages en live.",
    "unbanMessaging": "Debannir de la messagerie",
    "confirmUnbanMessaging": "Etes-vous sur de vouloir restaurer la capacite de cet utilisateur a envoyer des messages ?",
    "unbannedMessaging": "Utilisateur debanni de la messagerie",
    "suspended": "Utilisateur suspendu",
    "banned": "Utilisateur banni",
    "reactivated": "Utilisateur reactive",
    "actionFailed": "L'action a echoue",
    "loadFailed": "Impossible de charger l'utilisateur",
    "role": "Role",
    "currentRole": "Role actuel",
    "confirmSetRole": "Etes-vous sur de vouloir attribuer le role {{ role }} a {{ username }} ?",
    "confirmRoleChange": "Changer le role",
    "roleChanged": "Role mis a jour",
    "roleChangeFailed": "Impossible de changer le role",
    "grantAdmin": "Donner le rôle admin",
    "revokeAdmin": "Retirer le rôle admin",
    "confirmGrantAdmin": "Voulez-vous donner le rôle admin à {{username}} ?",
    "confirmRevokeAdmin": "Voulez-vous retirer le rôle admin à {{username}} ?",
    "relatedLinks": "Liens associés",
    "viewOrders": "Voir les commandes ({{count}})",
    "viewStrikes": "Voir les strikes ({{count}})",
    "viewReports": "Voir les signalements ({{count}})",
    "viewShop": "Voir la boutique",
    "restrictionDetails": "Détails de la restriction",
    "banReason": "Motif du bannissement",
    "suspensionExpiry": "Fin de la suspension",
    "preferences": {
      "sectionTitle": "Preferences utilisateur",
      "notificationsSectionTitle": "Preferences notifications",
      "locale": "Langue",
      "theme": "Apparence",
      "profileVisibility": "Visibilite du profil",
      "allowMessaging": "Messagerie",
      "category": "Categorie",
      "loadError": "Impossible de charger les preferences de l'utilisateur",
      "locales": {
        "fr": "Francais",
        "en": "Anglais"
      },
      "themes": {
        "LIGHT": "Clair",
        "DARK": "Sombre",
        "SYSTEM": "Systeme"
      },
      "visibilities": {
        "PUBLIC": "Public",
        "FOLLOWERS_ONLY": "Abonnes uniquement",
        "PRIVATE": "Prive"
      },
      "messagingPolicies": {
        "ALL": "Tous",
        "FOLLOWING_ONLY": "Personnes suivies uniquement",
        "NONE": "Personne"
      },
      "categories": {
        "transactional": "Transactionnel",
        "social": "Social",
        "live": "Live",
        "marketing": "Marketing"
      },
      "channels": {
        "push": "Push",
        "email": "E-mail",
        "sms": "SMS"
      },
      "notifications": {
        "lockedHint": "Toujours actif — requis par la loi Hamon."
      }
    },
    "discord": {
      "title": "Compte Discord",
      "linked": "Discord : connecté (@{{username}}) depuis le {{date}}",
      "notLinked": "Discord : non connecté",
      "presence": {
        "PRESENT": "Présent sur le serveur",
        "ABSENT": "Absent du serveur",
        "UNKNOWN": "Présence inconnue"
      },
      "recent": "Connecté récemment (moins de 72 heures)",
      "roles": "Rôles",
      "roleState": {
        "granted": "Attribué",
        "pending": "En attente",
        "review": "À régulariser",
        "notGranted": "Non attribué"
      },
      "syncStale": "Synchronisation en retard",
      "reason": {
        "ELIGIBLE": "Conditions remplies",
        "ACCOUNT_RESTRICTED": "Compte restreint (suspendu ou banni)",
        "NOT_A_VERIFIED_SELLER": "Demande vendeur non approuvée",
        "NO_ACTIVE_SHOP": "Aucune boutique active",
        "ACTIVE_STRIKE": "Avertissement acheteur actif",
        "NO_PAID_ORDER": "Aucune commande réglée",
        "HIDDEN_BY_MEMBER": "Masqué par le membre"
      },
      "sync": {
        "lastPass": "Dernier passage de rôles",
        "never": "Aucun passage",
        "failures": "Échecs consécutifs",
        "lastError": "Dernière erreur",
        "removalDeferredUntil": "Retrait différé jusqu'au"
      },
      "syncError": {
        "MEMBER_NOT_MANAGEABLE": "Discord refuse de modifier les rôles de ce membre (propriétaire du serveur ou rôle au-dessus de celui du bot). Aucune nouvelle tentative."
      },
      "unlink": "Déconnecter le compte Discord",
      "unlinkTitle": "Déconnexion forcée du compte Discord",
      "unlinkBody": "Les rôles Marchand ✓ et Looteur ✓ seront retirés de ce membre. Indiquez le motif, il est conservé dans le journal des actions. Si le compte est détourné, suspendez-le d'abord pour déconnecter ses sessions.",
      "unlinkConfirm": "Déconnecter Discord",
      "reasonPlaceholder": "Motif de la déconnexion de Discord (3 à 200 caractères)…",
      "blockRelink": "Empêcher une nouvelle connexion de ce compte Discord pendant 24 heures",
      "unlinked": "Compte Discord déconnecté.",
      "unlinkedBlocked": "Compte Discord déconnecté. Reconnexion bloquée pendant 24 heures.",
      "loadError": "Impossible de charger l'état Discord de ce compte.",
      "error": {
        "notLinked": "Ce compte Discord n'est plus connecté.",
        "disabled": "La connexion de comptes Discord est désactivée sur cet environnement. Rien n'a été déconnecté.",
        "unavailable": "La déconnexion du compte Discord est impossible : le blocage de la reconnexion n'a pas pu être enregistré. Rien n'a été déconnecté."
      }
    }
  },
  "sellerRequests": {
    "title": "Demandes vendeur",
    "detail": "Detail de la demande",
    "stats": "Statistiques",
    "preApprove": "Pre-approuver",
    "approve": "Approuver",
    "sendBack": "Renvoyer",
    "reject": "Rejeter",
    "revoke": "Revoquer l'acces",
    "applicantInfo": "Informations du demandeur",
    "companyInfo": "Informations entreprise",
    "personalInfo": "Informations personnelles",
    "businessInfo": "Informations commerciales",
    "noBusinessInfo": "Aucune information commerciale soumise pour le moment.",
    "address": "Adresse",
    "verification": "Verification",
    "existingRemarks": "Remarques admin",
    "adminActions": "Actions administrateur",
    "currentStatus": "Statut actuel",
    "preApproveDialogTitle": "Pre-approuver la demande",
    "preApproveDialogMessage": "Cela permettra au vendeur de completer son profil et de connecter Stripe. Etes-vous sur de vouloir pre-approuver cette demande ?",
    "approveDialogTitle": "Approuver la demande vendeur",
    "approveDialogMessage": "Cela accordera l'acces vendeur a cet utilisateur. Etes-vous sur de vouloir approuver cette demande ?",
    "rejectDialogTitle": "Rejeter la demande vendeur",
    "rejectDialogMessage": "Etes-vous sur de vouloir rejeter cette demande ? Veuillez ajouter des remarques pour expliquer la raison.",
    "sendBackDialogTitle": "Renvoyer pour correction",
    "sendBackDialogMessage": "Renvoyer cette demande au vendeur pour correction. Ajoutez des remarques pour expliquer ce qui doit etre corrige.",
    "revokeDialogTitle": "Revoquer l'acces vendeur",
    "revokeDialogMessage": "Vous etes sur le point de revoquer definitivement l'acces vendeur. Cette action est irreversible. Veuillez fournir une raison detaillee.",
    "revokeConsequencesTitle": "Consequences de la revocation",
    "revokeConsequence1": "Le role vendeur sera retire du compte utilisateur",
    "revokeConsequence2": "Tous les articles en vente seront archives et depublies",
    "revokeConsequence3": "Les lives actifs et planifies seront stoppes immediatement",
    "revokeConsequence4": "Le compte Stripe Connect sera desactive",
    "revokeRemarksPlaceholder": "Expliquez la raison de la revocation de l'acces vendeur (obligatoire)...",
    "remarksPlaceholder": "Ajouter des remarques...",
    "status": {
      "SUBMITTED": "Soumise",
      "PRE_APPROVED": "Pre-approuvee",
      "COMPLETING": "En cours",
      "PENDING_REVIEW": "En attente de revision",
      "APPROVED": "Approuvee",
      "REJECTED": "Rejetee",
      "REVOKED": "Revoquee"
    }
  },
  "buyerStrikes": {
    "title": "Penalites acheteur",
    "lookupPlaceholder": "Utilisateur",
    "searchUserPlaceholder": "Rechercher par nom d'utilisateur...",
    "clear": "Annuler la penalite",
    "confirmClear": "Etes-vous sur de vouloir annuler cette penalite ?",
    "clearReasonPlaceholder": "Expliquez la raison de l'annulation de la pénalité (5 caractères minimum)…"
  },
  "sellerDebts": {
    "title": "Dettes vendeurs",
    "filterSeller": "Vendeur",
    "searchSellerPlaceholder": "Rechercher par nom d'utilisateur...",
    "totalOutstanding": "Total des dettes en cours",
    "writeOff": "Annuler la dette",
    "confirmWriteOff": "Etes-vous sur de vouloir annuler (write-off) cette dette ? Cette action est irreversible.",
    "writeOffReasonPlaceholder": "Expliquez la raison de l'annulation (minimum 5 caracteres)...",
    "loadError": "Echec du chargement des dettes vendeurs.",
    "status": {
      "OUTSTANDING": "En cours",
      "RESOLVED": "Resolue",
      "WRITTEN_OFF": "Annulee"
    },
    "toast": {
      "writtenOff": "Dette annulee avec succes"
    }
  },
  "orders": {
    "title": "Gestion des commandes",
    "detail": "Detail de la commande",
    "orderPrefix": "Commande",
    "searchPlaceholder": "Rechercher par numero de commande ou acheteur...",
    "ordersFound": "{{count}} commande(s) trouvee(s)",
    "allStatuses": "Tous les statuts",
    "allSources": "Toutes les sources",
    "cancelOrder": "Annuler la commande",
    "markDelivered": "Marquer comme livre",
    "confirmCancel": "Etes-vous sur de vouloir annuler cette commande ? Cette action est irreversible.",
    "confirmDeliver": "Etes-vous sur de vouloir marquer cette commande comme livree ?",
    "cancelSuccess": "Commande annulee avec succes",
    "deliverSuccess": "Commande marquee comme livree",
    "actionFailed": "L'action a echoue",
    "loadError": "Impossible de charger les details de la commande",
    "cancelReason": "Raison d'annulation",
    "cancelReasons": {
      "fullyRefunded": "Commande intégralement remboursée",
      "expired": "Paiement non finalisé à temps, commande expirée",
      "paymentFailed": "Paiement refusé"
    },
    "pending": "En attente",
    "timeline": "Chronologie",
    "timelineCreated": "Creee",
    "timelineConfirmed": "Confirmee",
    "timelineShipped": "Expediee",
    "timelineDelivered": "Livree",
    "timelineCancelled": "Annulee",
    "buyerAndShop": "Acheteur & Boutique",
    "buyer": "Acheteur",
    "shop": "Boutique",
    "items": "Articles",
    "qty": "Qte",
    "amounts": "Montants",
    "subtotal": "Sous-total",
    "shipping": "Livraison",
    "platformFee": "Frais plateforme",
    "total": "Total",
    "delivery": "Livraison",
    "carrier": "Transporteur",
    "trackingNumber": "Numero de suivi",
    "trackingLink": "Lien de suivi",
    "trackOrder": "Suivre la commande",
    "deliveryMethod": "Methode de livraison",
    "deliveryPoint": "Point relais",
    "downloadLabel": "Telecharger l'etiquette",
    "labelDownloadFailed": "Echec du telechargement de l'etiquette",
    "shippedAt": "Expedie le",
    "deliveredAt": "Livre le",
    "shippingAddress": "Adresse de livraison",
    "status": {
      "PENDING": "En attente",
      "CONFIRMED": "Confirmee",
      "READY_TO_SHIP": "Prete a expedier",
      "SHIPPED": "Expediee",
      "DELIVERED": "Livree",
      "COMPLETED": "Terminee",
      "CANCELED": "Annulee"
    },
    "source": {
      "CART": "Panier",
      "LIVE": "Live"
    },
    "retryInvoices": "Generer les factures",
    "invoiceRetryLoading": "Generation...",
    "invoiceRetrySuccess": "{{count}} facture(s) generee(s)",
    "invoiceRetryNone": "Aucune facture a generer",
    "invoiceResults": "Resultat de la generation",
    "invoiceGenerated": "Generee",
    "invoiceSubmitted": "Soumise a Pennylane",
    "invoiceSkipped": "Ignoree",
    "invoiceFailed": "Echec",
    "invoiceNotApplicable": "Non applicable",
    "invoiceRequiresReview": "Revue manuelle requise",
    "retryPennylane": "Generer les PDF",
    "pennylaneRetryLoading": "Generation en cours...",
    "pennylaneRetrySuccess": "{{count}} facture(s) traitee(s)",
    "pennylaneRetryFailed": "{{count}} facture(s) en echec",
    "pennylaneRetryNone": "Aucune facture a traiter",
    "pennylaneRetryRequiresReview": "Revue PDP manuelle requise pour {{count}} facture(s). Aucun nouveau brouillon n'a été créé.",
    "invoiceType": {
      "BUYER_FEE_INVOICE": "Facture frais acheteur",
      "SELLER_CUSTOMER_INVOICE": "Facture client vendeur",
      "SELLER_FEE_INVOICE": "Facture frais vendeur"
    },
    "invoices": "Factures",
    "invoicesNone": "Aucune facture pour cette commande",
    "invoicesLoadError": "Impossible de charger les factures",
    "invoiceNumber": "Numero",
    "invoiceStatus": {
      "PENDING": "En attente",
      "GENERATED": "Generee",
      "FAILED": "Echouee",
      "SUBMITTED_TO_PDP": "Soumise au PDP",
      "ACCEPTED_BY_PDP": "Acceptee par le PDP",
      "REJECTED_BY_PDP": "Rejetee par le PDP"
    },
    "invoiceHt": "HT",
    "invoiceVat": "TVA",
    "invoiceVatRate": "Taux TVA",
    "invoiceTotal": "Total TTC",
    "invoiceDownload": "Telecharger le PDF",
    "invoiceCreatedAt": "Creee le",
    "invoiceLineItems": "Lignes de facture",
    "invoiceLineDescription": "Description",
    "invoiceLineQty": "Qte",
    "invoiceLineUnitPrice": "Prix unit.",
    "invoiceLineVat": "TVA",
    "invoiceLineTotal": "Total",
    "invoiceSubtotalHt": "Sous-total HT",
    "invoiceTotalVat": "Total TVA",
    "invoiceTotalTtc": "Total TTC",
    "invoiceLegalMention": "Mention legale",
    "invoiceNoLineItems": "Aucune ligne de facture",
    "invoiceToggleDetail": "Details"
  },
  "lives": {
    "title": "Lives",
    "detail": "Detail du live",
    "searchPlaceholder": "Rechercher par titre ou vendeur...",
    "livesFound": "{{count}} live(s) trouve(s)",
    "forceStop": "Arreter",
    "allStatuses": "Tous les statuts",
    "shop": "Boutique",
    "seller": "Vendeur",
    "user": "Utilisateur",
    "generalInfo": "Informations generales",
    "category": "Categorie",
    "entryPoint": "Point d'entree",
    "notification": "Notification",
    "followers": "Abonnes",
    "participants": "Participants",
    "peakViewers": "Pic de viewers",
    "createdAt": "Date de creation",
    "planning": "Planification",
    "statusLabel": "Statut",
    "scheduledDate": "Date planifiee",
    "startedDate": "Date de debut",
    "endedDate": "Date de fin",
    "media": "Medias",
    "coverImage": "Image de couverture",
    "presentationVideo": "Video de presentation",
    "presentationVideoId": "ID de la video",
    "items": "Articles",
    "itemImage": "Image",
    "itemName": "Nom",
    "itemType": "Type",
    "itemStatus": "Statut",
    "itemPrice": "Prix",
    "itemCurrentPrice": "Prix actuel",
    "itemBids": "Encheres",
    "itemStarted": "Debut",
    "streaming": "Streaming",
    "streamingStatus": "Statut du streaming",
    "orchestratorLiveId": "ID Orchestrateur",
    "hlsUrl": "URL HLS",
    "cdnHlsUrl": "URL HLS CDN",
    "vodUrl": "URL VOD",
    "hlsMode": "Mode HLS",
    "streamMonitor": "Moniteur du flux en direct",
    "dvrLive": "Rewind en direct (DVR)",
    "replay": "Replay du live",
    "streamLoading": "Chargement du flux...",
    "streamUnavailable": "Flux indisponible",
    "streamRetry": "Reessayer",
    "lastRefreshed": "Actualise il y a {{seconds}}s",
    "forceStopConfirmTitle": "Arreter le live",
    "forceStopConfirmMessage": "Etes-vous sur de vouloir arreter le live \"{{title}}\" ? Cela mettra fin immediatement a la diffusion pour tous les spectateurs.",
    "webrtc": {
      "label": "Flux WebRTC viewer",
      "help": "Active : les viewers recoivent un flux sub-seconde (jusqu'a 160 simultanes, au-dela bascule automatique en LL-HLS). Desactive : tous les viewers en LL-HLS (latence ~3-5 s, mais diffusion CDN illimitee). Les diffuseurs ne sont jamais affectes.",
      "disabledHint": "Modifiable uniquement tant que le live n'est pas termine.",
      "enabled": "Flux WebRTC viewer active",
      "disabled": "Flux WebRTC viewer desactive",
      "failed": "Echec de la mise a jour du flux WebRTC viewer"
    },
    "webrtcGlobal": {
      "title": "Transport viewer (global)",
      "mode": {
        "auto": "Auto",
        "force_on": "Force WebRTC",
        "force_off": "Force LL-HLS"
      },
      "autoHelp": "Auto : chaque live suit son propre reglage WebRTC. C'est le mode par defaut.",
      "force_onHelp": "Force WebRTC : tous les lives sont forces en WebRTC sub-seconde (jusqu'a 160 viewers/noeud, au-dela bascule automatique en LL-HLS).",
      "force_offHelp": "Force LL-HLS (kill-switch) : tous les lives sont forces en LL-HLS et les viewers WebRTC deja connectes sont evinces immediatement.",
      "evictionWarning": "Force LL-HLS evince immediatement les viewers WebRTC connectes. Action plateforme-wide.",
      "confirm": {
        "title": "Changer le transport viewer global",
        "apply": "Appliquer",
        "force_onMessage": "Forcer TOUS les lives en WebRTC ? Cela s'applique a l'ensemble de la plateforme (fallback LL-HLS automatique au-dela de 160 viewers par noeud).",
        "force_offMessage": "Forcer TOUS les lives en LL-HLS ? Cela coupe le WebRTC sur l'ensemble de la plateforme et evince immediatement tous les viewers WebRTC actuellement connectes."
      },
      "updated": "Transport viewer global mis a jour",
      "updateFailed": "Echec de la mise a jour du transport viewer global",
      "loadFailed": "Echec du chargement du transport viewer global"
    },
    "chat": {
      "loading": "Chargement des messages...",
      "empty": "Aucun message pour le moment",
      "moderated": "MODERE",
      "reason": "Raison",
      "showOriginal": "Voir le message original",
      "hideOriginal": "Masquer l'original",
      "confirmHide": "Masquer ce message ?",
      "confirmBan": "Bannir {{username}} ?",
      "hideTooltip": "Masquer le message",
      "banTooltip": "Bannir l'utilisateur du chat",
      "unhide": "Restaurer",
      "muteTooltip": "Rendre muet",
      "ejectTooltip": "Ejecter du live",
      "muteDuration": "Rendre muet pendant :",
      "confirmEject": "Ejecter {{username}} ?",
      "loadOlder": "Charger les messages precedents"
    },
    "tabInfo": "Infos",
    "tabChat": "Chat",
    "tabSales": "Ventes",
    "tabBans": "Bans",
    "bannedUsers": "Utilisateurs bannis",
    "bannedUser": "Utilisateur",
    "bannedByLabel": "Banni par",
    "bannedDate": "Date",
    "noBannedUsers": "Aucun utilisateur banni pour ce shop",
    "shopLevel": "Niveau shop",
    "unban": "Debannir",
    "activeSale": "Vente en cours",
    "soldItemsSection": "Articles vendus",
    "queuedItems": "En attente",
    "status": {
      "LIVE": "En direct",
      "SCHEDULED": "Planifie",
      "DRAFT": "Brouillon",
      "DONE": "Termine"
    }
  },
  "discounts": {
    "title": "Reductions",
    "createDiscount": "Creer une reduction",
    "code": "Code",
    "description": "Description",
    "type": "Type",
    "amount": "Montant",
    "minOrderAmount": "Montant minimum de commande",
    "value": "Valeur",
    "maxUses": "Utilisations max",
    "startsAt": "Debut",
    "expiresAt": "Expire le",
    "disable": "Desactiver",
    "enable": "Reactiver",
    "disableConfirmTitle": "Desactiver la reduction",
    "disableConfirmMessage": "Desactiver le code de reduction {{code}} ? Il ne sera plus utilisable au paiement.",
    "cannotEnableExpired": "Cette reduction a expire et ne peut pas etre reactivee.",
    "toast": {
      "created": "Reduction creee avec succes",
      "validationError": "Veuillez remplir tous les champs obligatoires",
      "disabled": "Reduction desactivee",
      "enabled": "Reduction reactivee"
    }
  },
  "referralCampaigns": {
    "title": "Campagnes de parrainage",
    "create": "Creer une campagne",
    "detail": "Detail de la campagne",
    "edit": "Modifier la campagne",
    "deactivate": "Desactiver",
    "userId": "Utilisateur",
    "searchUserPlaceholder": "Rechercher par nom d'utilisateur...",
    "referrerAmount": "Montant parrain",
    "refereeAmount": "Montant filleul",
    "minQualifyingOrder": "Commande minimum",
    "maxReferralsPerMonth": "Parrainages max/mois",
    "lifetimeMaxReferrals": "Max parrainages total",
    "startsAt": "Debut",
    "endsAt": "Fin",
    "toast": {
      "deleted": "Campagne supprimee",
      "deleteFailed": "Echec de la suppression de la campagne"
    }
  },
  "categories": {
    "title": "Categories",
    "category": "Categorie",
    "label": "Libelle",
    "shortName": "Nom court",
    "pictureUrl": "URL de l'image",
    "position": "Position",
    "isOnboarding": "Onboarding",
    "parentCategory": "Categorie parente",
    "noParent": "Aucune (categorie racine)",
    "parentHint": "Laisser vide pour creer une categorie racine.",
    "addCategory": "Ajouter une categorie",
    "editCategory": "Modifier la categorie",
    "addCondition": "Ajouter un etat",
    "addWeight": "Ajouter un grammage",
    "weight": "Poids",
    "toggle": "Activer/Desactiver",
    "activate": "Activer",
    "deactivate": "Desactiver",
    "name": "Nom",
    "slug": "Slug",
    "active": "Actif",
    "empty": "Aucune categorie. Creez-en une pour commencer.",
    "edit": {
      "upload": {
        "title": "Televerser une image",
        "currentImageAlt": "Image actuelle de la categorie",
        "noImage": "Aucune image",
        "successToast": "Image televersee"
      }
    }
  },
  "shared": {
    "imageUpload": {
      "title": "Televerser une image",
      "hint": "PNG, JPEG ou WEBP, max 5 Mo",
      "uploading": "Televersement...",
      "openPicker": "Ouvrir le selecteur de fichier",
      "errors": {
        "invalidType": "Format non supporte. Utilisez PNG, JPEG ou WEBP.",
        "tooLarge": "Fichier trop volumineux. Maximum 5 Mo.",
        "network": "Echec du televersement. Reessayez."
      }
    }
  },
  "deliveryCarriers": {
    "title": "Transporteurs",
    "list": "Transporteurs actifs",
    "upsert": "Ajouter un transporteur",
    "editCarrier": "Modifier le transporteur",
    "carrier": "Transporteur",
    "carrierName": "Nom du transporteur",
    "carrierCode": "Code transporteur",
    "pictureUrl": "URL de l'image",
    "position": "Position",
    "active": "Actif",
    "mandatory": "Obligatoire",
    "required": "Requis",
    "codeReadonly": "Le code transporteur ne peut pas etre modifie apres creation.",
    "empty": "Aucun transporteur pour le moment.",
    "shippingRates": "Tarifs d'expedition",
    "syncShippingRates": "Synchroniser les tarifs",
    "syncShippingRatesDescription": "Synchronise les tarifs d'expedition depuis Sendcloud. Cette operation peut prendre quelques minutes.",
    "syncing": "Synchronisation en cours...",
    "syncSuccess": "Synchronisation terminee : {{synced}} tarif(s) synchronise(s), {{deleted}} supprime(s)",
    "syncError": "Erreur lors de la synchronisation des tarifs",
    "viewShippingRates": "Voir les tarifs"
  },
  "shippingRates": {
    "title": "Tarifs d'expedition",
    "ratesFound": "{{count}} tarif(s) trouve(s)",
    "allCarriers": "Tous les transporteurs",
    "allFromCountries": "Tous les pays d'origine",
    "allToCountries": "Tous les pays de destination",
    "sync": "Synchronisation",
    "syncDescription": "Synchronise les tarifs d'expedition depuis Sendcloud. Cette operation peut prendre quelques minutes.",
    "backToCarriers": "Retour aux transporteurs",
    "syncDispatched": "Synchronisation lancee — les tarifs seront mis a jour sous peu",
    "showing": "Affichage de {{displayed}} sur {{total}}",
    "loadMore": "Charger plus"
  },
  "searchAdmin": {
    "title": "Administration de la recherche",
    "reindex": "Reindexer",
    "analytics": "Analytiques",
    "sourceType": "Type de source",
    "triggerReindex": "Lancer la reindexation",
    "trending": "Recherches tendances",
    "topClicked": "Plus cliques",
    "reindexWarning": "Cela reconstruira l'index de recherche. L'operation peut prendre plusieurs minutes et affecter temporairement les resultats.",
    "sourceItems": "Articles",
    "sourceShops": "Boutiques",
    "confirmReindex": "Etes-vous sur de vouloir reindexer {{sourceType}} ? Cela peut prendre plusieurs minutes.",
    "loadError": "Impossible de charger les analytiques de recherche",
    "reindexTriggered": "Reindexation lancee",
    "reindexFailed": "Echec de la reindexation",
    "noTrending": "Aucune recherche tendance pour le moment.",
    "noClickData": "Aucune donnee de clic pour le moment.",
    "sourceLives": "Lives"
  },
  "reconciliation": {
    "title": "Reconciliation",
    "runs": "Executions de reconciliation",
    "runNow": "Executer maintenant",
    "detail": "Details de l'execution",
    "discrepancies": "Ecarts",
    "runId": "ID execution",
    "startedAt": "Debut",
    "completedAt": "Fin",
    "confirmRun": "Etes-vous sur de vouloir lancer une reconciliation ? Cela comparera tous les enregistrements de paiement avec Stripe.",
    "runStarted": "Reconciliation lancee",
    "runFailed": "Impossible de lancer la reconciliation"
  },
  "messages": {
    "title": "Messagerie",
    "tabs": {
      "browse": "Parcourir",
      "search": "Rechercher"
    }
  },
  "flaggedQueue": {
    "title": "File de contenu signale",
    "allTypes": "Tous les types",
    "minReports": "Min {{count}} signalement(s)",
    "pendingCount": "{{count}} element(s) en attente de revision",
    "colType": "Type",
    "colContent": "Contenu",
    "colOwner": "Auteur",
    "colReports": "Signalements",
    "colLatest": "Dernier signalement",
    "colStatus": "Statut",
    "empty": "Aucun contenu signale. Tout est en ordre !",
    "hide": "Masquer",
    "dismiss": "Rejeter",
    "hideContent": "Masquer ce contenu",
    "dismissAll": "Rejeter tous les signalements",
    "viewReports": "Voir les signalements",
    "confirmHideTitle": "Masquer le contenu",
    "confirmHideMessage": "Etes-vous sur de vouloir masquer ce contenu ? Cela le marquera comme masque et resoudra tous les signalements associes.",
    "confirmDismissTitle": "Rejeter les signalements",
    "confirmDismissMessage": "Etes-vous sur de vouloir rejeter tous les signalements pour ce contenu ? Le contenu restera visible.",
    "hiddenSuccess": "Contenu masque avec succes",
    "dismissedSuccess": "Signalements rejetes",
    "type": {
      "MESSAGE": "Message",
      "LIVE_MESSAGE": "Message Live",
      "COMMENT": "Commentaire",
      "ITEM": "Article",
      "LIVE": "Live",
      "REVIEW": "Avis"
    }
  },
  "conversations": {
    "title": "Conversations",
    "detail": "Detail de la conversation",
    "searchPlaceholder": "Rechercher par ID utilisateur ou nom...",
    "filterByType": "Filtrer par type",
    "participants": "Participants",
    "type": "Type",
    "lastMessage": "Dernier message",
    "lastMessageDate": "Date du dernier message",
    "messageCount": "Messages",
    "messagesLabel": "messages",
    "messages": "Messages",
    "createdAt": "Creation",
    "info": "Info conversation",
    "noMessages": "Aucun message dans cette conversation.",
    "loadOlder": "Charger les messages precedents",
    "hidden": "Masque",
    "hiddenBy": "Masque par",
    "showOriginal": "Voir l'original",
    "hideOriginal": "Masquer l'original",
    "hideMessage": "Masquer le message",
    "hideMessageTitle": "Masquer le message",
    "hideMessageConfirm": "Etes-vous sur de vouloir masquer ce message ? L'expediteur ne le verra plus.",
    "hideReasonPlaceholder": "Indiquez la raison du masquage de ce message...",
    "hideSuccess": "Message masque avec succes",
    "unhide": "Restaurer",
    "unhideSuccess": "Message restaure avec succes",
    "selectMessages": "Selectionner",
    "cancelSelection": "Annuler la selection",
    "selectedCount": "{{count}} message(s) selectionne(s)",
    "selectAll": "Tout selectionner",
    "clearSelection": "Effacer",
    "hideSelected": "Masquer la selection",
    "bulkHideTitle": "Masquer les messages selectionnes",
    "bulkHideConfirm": "Etes-vous sur de vouloir masquer {{count}} message(s) selectionne(s) ? Les expediteurs ne les verront plus.",
    "bulkHideSuccess": "{{count}} message(s) masque(s) avec succes",
    "emptyTitle": "Aucune conversation trouvee",
    "emptyDescription": "Essayez de rechercher par ID utilisateur ou nom, ou ajustez le filtre de type.",
    "type.BUYER_SHOP": "Acheteur-Boutique",
    "type.USER_USER": "Utilisateur-Utilisateur",
    "type.GROUP": "Groupe"
  },
  "messageSearch": {
    "title": "Recherche de messages",
    "placeholder": "Rechercher des messages par contenu...",
    "content": "Contenu",
    "sender": "Expediteur",
    "source": "Source",
    "status": "Statut",
    "date": "Date",
    "emptyTitle": "Aucun message trouve",
    "emptyDescription": "Essayez une autre recherche."
  },
  "queues": {
    "title": "Gestion des files d'attente",
    "lastUpdated": "Derniere mise a jour :",
    "refresh": "Actualiser",
    "healthyQueues": "En bonne sante",
    "degradedQueues": "Degradees",
    "totalFailed": "Echecs totaux",
    "pausedQueues": "En pause",
    "scheduledJobs": "Files planifiees",
    "eventDrivenQueues": "Files evenementielles",
    "noScheduledQueues": "Aucune file planifiee.",
    "noEventDrivenQueues": "Aucune file evenementielle.",
    "critical": "Critique",
    "recovered": "Rétabli",
    "stillFailing": "En erreur",
    "pause": "Pause",
    "resume": "Reprendre",
    "retryFailed": "Reessayer",
    "description": "Description",
    "schedule": "Planification",
    "type": "Type",
    "status": "Statut",
    "typeRepeatable": "Planifie (cron)",
    "typeEventDriven": "Evenementiel",
    "failedJobsDetail": "Detail des echecs",
    "loadMoreFailed": "Charger plus d'echecs",
    "confirmPauseTitle": "Mettre en pause",
    "confirmPauseCriticalTitle": "Mettre en pause (file critique)",
    "confirmResumeTitle": "Reprendre le traitement",
    "confirmRetryTitle": "Reessayer les echecs",
    "counter": {
      "active": "Actifs",
      "waiting": "En attente",
      "delayed": "Differes",
      "done": "Termines",
      "failed": "Echecs"
    },
    "table": {
      "queue": "File",
      "jobId": "ID du job",
      "jobName": "Nom du job",
      "error": "Erreur",
      "attempts": "Tentatives",
      "failedAt": "Echoue le"
    },
    "detail": {
      "errorMessage": "Message d'erreur",
      "stackTrace": "Stack trace",
      "jobName": "Nom du job",
      "jobId": "ID du job",
      "attempts": "Tentatives",
      "failedAt": "Echoue le"
    },
    "dlq": {
      "title": "Dead Letter Queue",
      "unresolved": "DLQ non resolus",
      "noEntries": "Aucune entree dans la dead letter queue.",
      "allQueues": "Toutes les files",
      "retry": "Relancer",
      "resolve": "Resoudre",
      "loadMore": "Charger plus",
      "createdAt": "Cree le",
      "payload": "Donnees",
      "detailTitle": "Detail du job DLQ"
    }
  },
  "shops": {
    "title": "Boutiques",
    "searchPlaceholder": "Rechercher par nom de boutique...",
    "shopsFound": "boutique(s) trouvee(s)",
    "shopInfo": "Informations de la boutique",
    "sellerType": "Type de vendeur",
    "vatRate": "Taux de TVA",
    "followers": "Abonnes",
    "totalItems": "Articles",
    "totalOrders": "Commandes",
    "created": "Creation",
    "updated": "Derniere modification",
    "sellerInfo": "Informations du vendeur",
    "stripeInfo": "Informations Stripe",
    "chargesEnabled": "Paiements actifs",
    "payoutsEnabled": "Virements actifs",
    "shippingAddress": "Adresse d'expedition",
    "street": "Rue",
    "city": "Ville",
    "postalCode": "Code postal",
    "country": "Pays",
    "region": "Region",
    "presentationVideo": "Video de presentation",
    "actions": "Actions",
    "revokeSeller": "Revoquer l'acces vendeur",
    "sellerRequestStatus": "Statut demande vendeur",
    "revokeSuccess": "Acces vendeur revoque",
    "revokeFailed": "Impossible de revoquer l'acces vendeur",
    "loadFailed": "Impossible de charger la boutique",
    "vacation": "En vacances",
    "vacationStatus": "Mode vacances",
    "vacationSince": "En vacances depuis",
    "stripeSync": {
      "button": "Resynchroniser Stripe",
      "title": "Synchro Stripe",
      "syncing": "Synchronisation...",
      "started": "Synchronisation Stripe lancée",
      "confirm": "Mettre à jour le statut Stripe de toutes les boutiques ? La synchronisation s'exécute en arrière-plan, vous pouvez suivre son avancement sur cette page.",
      "confirmLabel": "Lancer la synchro",
      "rateLimited": "Trop de tentatives. Réessayez dans une minute.",
      "failed": "Échec de la resynchronisation Stripe. Réessayez.",
      "empty": "Aucune synchronisation pour l'instant.",
      "loadError": "Impossible de charger la dernière synchronisation.",
      "trackingLost": "Suivi interrompu : le statut affiché n'est peut-être plus à jour.",
      "queuedHint": "En attente de démarrage…",
      "caption": "{{total}} boutique(s) analysée(s)",
      "captionWithInternal": "{{total}} boutique(s) analysée(s), dont {{internal}} interne(s) sans compte Stripe Connect (ignorée(s))",
      "runFailedHint": "La synchronisation s'est arrêtée avant la fin ({{processed}} boutique(s) traitée(s)). Relancez-la.",
      "failuresTitle": "{{count}} boutique(s) en erreur",
      "failuresHint": "Cliquez sur une ligne pour ouvrir la fiche. Erreur Stripe : relancez la synchro. Compte introuvable : contactez le vendeur.",
      "failuresTruncated": "Seules les {{count}} premières boutiques sont listées. Relancez la synchronisation pour retraiter les autres.",
      "status": {
        "QUEUED": "En file",
        "RUNNING": "En cours",
        "COMPLETED": "Terminée",
        "COMPLETED_WITH_ERRORS": "Terminée avec erreurs",
        "FAILED": "Échec"
      },
      "trigger": {
        "ADMIN": "Manuelle",
        "CRON": "Automatique"
      },
      "meta": {
        "running": "{{trigger}} · démarrée le {{date}}",
        "finished": "{{trigger}} · {{date}} · {{duration}}"
      },
      "progress": {
        "label": "Progression de la synchronisation Stripe",
        "counter": "{{processed}} / {{total}} boutique(s) traitée(s)",
        "counterNoTotal": "{{processed}} boutique(s) traitée(s)",
        "announce": "Synchronisation en cours : {{percent}} %",
        "announceNoTotal": "Synchronisation en cours"
      },
      "kpi": {
        "updated": "Mises à jour",
        "unchanged": "Déjà à jour",
        "errors": "En erreur"
      },
      "col": {
        "shop": "Boutique",
        "problem": "Problème"
      },
      "toast": {
        "completed": "Synchronisation Stripe terminée",
        "completedWithErrors": "Synchronisation Stripe terminée : {{count}} boutique(s) en erreur"
      },
      "reason": {
        "stripe_account_unavailable": "Compte introuvable chez Stripe",
        "stripe_lookup_failed": "Erreur Stripe, réessayer",
        "shop_update_failed": "Mise à jour échouée",
        "unknown": "Motif inconnu"
      }
    }
  },
  "toast": {
    "success": "Succes",
    "error": "Erreur",
    "warning": "Attention",
    "info": "Information"
  },
  "adminActions": {
    "title": "Actions administrateur",
    "searchPlaceholder": "Rechercher par ID cible...",
    "actionsFound": "{{count}} action(s) trouvee(s)",
    "allActions": "Toutes les actions",
    "allTargets": "Toutes les cibles",
    "action": "Action",
    "targetType": "Type de cible",
    "targetId": "ID cible",
    "reason": "Raison",
    "admin": "Admin",
    "date": "Date",
    "dateTo": "au",
    "facetsLoadFailed": "Impossible de charger les filtres. Les filtres existants restent disponibles.",
    "close": "Fermer",
    "metadata": "Metadonnees",
    "ipAddress": "Adresse IP",
    "userAgent": "User-agent",
    "viewDetails": "Cliquez sur une ligne pour voir le detail.",
    "noReason": "Aucune raison renseignee",
    "actionLabels": {
      "SELLER_ACCESS_REVOKED": "Acces vendeur revoque",
      "SELLER_REQUEST_SENT_BACK": "Demande vendeur renvoyee pour correction",
      "SELLER_REQUEST_REJECTED": "Demande vendeur rejetee",
      "SELLER_REQUEST_APPROVED": "Demande vendeur approuvee",
      "SELLER_REQUEST_PRE_APPROVED": "Demande vendeur pre-approuvee",
      "SHOP_SELLER_REVOKED": "Vendeur retire de la boutique",
      "ORDER_DELIVERED": "Commande marquee livree",
      "ORDER_CANCELLED": "Commande annulee",
      "ORDER_PENNYLANE_SUBMISSION_RETRIED": "Nouvel envoi Pennylane de la commande",
      "ORDER_INVOICES_RETRIED": "Generation des factures de la commande relancee",
      "REFERRAL_CAMPAIGN_CREATED": "Campagne de parrainage creee",
      "REFERRAL_CAMPAIGN_UPDATED": "Campagne de parrainage modifiee",
      "REFERRAL_CAMPAIGN_DEACTIVATED": "Campagne de parrainage desactivee",
      "USER_MESSAGING_BANNED": "Utilisateur banni de la messagerie",
      "USER_MESSAGING_UNBANNED": "Utilisateur reintegre dans la messagerie",
      "USER_SUSPENDED": "Utilisateur suspendu",
      "USER_REACTIVATED": "Utilisateur reactive",
      "USER_BANNED": "Utilisateur banni",
      "ADMIN_ROLE_GRANTED": "Role admin accorde",
      "ADMIN_ROLE_REVOKED": "Role admin retire",
      "COMMENT_HIDDEN": "Commentaire masque",
      "LIVE_TERMINAL_EVENT_REQUEUED": "Evenement terminal du Live remis en file",
      "RECONCILIATION_TRIGGERED": "Reconciliation lancee",
      "CATEGORY_CREATED": "Categorie creee",
      "CATEGORY_UPDATED": "Categorie modifiee",
      "CATEGORY_TOGGLED": "Categorie activee ou desactivee",
      "WEIGHT_CREATED": "Poids cree",
      "CONDITION_CREATED": "Etat cree",
      "SHOP_SUSPENDED": "Boutique suspendue",
      "SHOP_UNSUSPENDED": "Boutique reactivee",
      "MESSAGE_HIDDEN": "Message masque",
      "MESSAGES_BULK_HIDDEN": "Messages masques en masse",
      "MESSAGE_UNHIDDEN": "Message reaffiche",
      "BUYER_STRIKE_CLEARED": "Strike acheteur leve",
      "DISCOUNT_CREATED": "Remise creee",
      "DISCOUNT_ENABLED": "Remise activee",
      "DISCOUNT_DISABLED": "Remise desactivee",
      "SEARCH_REINDEX_TRIGGERED": "Reindexation de la recherche lancee",
      "ITEM_AUCTION_FORCE_ENDED": "Enchere terminee de force",
      "ITEM_FLAG_CLEARED": "Signalement de l'item leve",
      "ITEM_FLAGGED": "Item signale",
      "ITEM_ADMIN_REPUBLISHED": "Item republie par un admin",
      "ITEM_ADMIN_UNPUBLISHED": "Item depublie par un admin",
      "ITEM_ADMIN_EDITED": "Item modifie par un admin",
      "ITEM_ADMIN_FORCE_DELETED": "Item supprime de force par un admin",
      "ITEM_GIVEAWAY_FORCE_DRAWN": "Tirage du Giveaway force",
      "ITEM_FORCE_LAUNCHED": "Lancement de l'item force",
      "REVIEW_HIDDEN": "Avis masque",
      "REVIEW_REPUBLISHED": "Avis republie",
      "REVIEW_REJECTED": "Avis rejete",
      "LIVE_FORCE_STOPPED": "Live arrete de force",
      "VIEWER_MUTED": "Spectateur rendu muet",
      "VIEWER_UNMUTED": "Spectateur reautorise a parler",
      "VIEWER_EJECTED": "Spectateur expulse",
      "LIVE_MESSAGE_HIDDEN": "Message du Live masque",
      "LIVE_MESSAGE_UNHIDDEN": "Message du Live reaffiche",
      "SELLER_DEBT_WRITTEN_OFF": "Dette vendeur passee en perte",
      "WALLET_CREDITED": "Wallet credite par un admin",
      "DELIVERY_CARRIER_UPSERTED": "Transporteur cree ou modifie",
      "REPORT_DISMISSED": "Signalement classe sans suite",
      "REPORT_ADMIN_NOTE_SET": "Note admin ajoutee au signalement",
      "REPORT_RESOLVED": "Signalement resolu",
      "REPORT_REVIEW_STARTED": "Examen du signalement commence",
      "FLAGGED_CONTENT_HIDDEN": "Contenu signale masque",
      "FLAGGED_CONTENT_DISMISSED": "Contenu signale classe sans suite",
      "SUPPORT_TICKET_REPLIED": "Reponse au ticket support",
      "SUPPORT_TICKET_STATUS_CHANGED": "Statut du ticket support modifie",
      "PAYMENT_REFUNDED": "Paiement rembourse",
      "LIVE_VIEWER_BANNED": "Spectateur banni du Live",
      "LIVE_VIEWER_MUTED": "Spectateur rendu muet dans la boutique",
      "LIVE_VIEWER_UNBANNED": "Spectateur debanni du Live",
      "LIVE_SHOP_BAN_LIFTED": "Bannissement de la boutique du Live leve",
      "SHOP_SLUG_CHANGED": "Slug de la boutique modifie",
      "PRODUCT_REQUEST_ENRICHED": "Demande de produit enrichie",
      "PRODUCT_REQUEST_VALIDATED": "Demande de produit validee",
      "PRODUCT_REQUEST_REJECTED": "Demande de produit rejetee",
      "QUEUE_PAUSED": "File d'attente mise en pause",
      "QUEUE_RESUMED": "File d'attente reprise",
      "QUEUE_FAILED_JOBS_RETRIED": "Jobs en echec de la file relances",
      "DEAD_LETTER_JOB_RESOLVED": "Job en dead letter resolu",
      "DEAD_LETTER_JOB_RETRIED": "Job en dead letter relance",
      "FAILED_EVENT_REPLAYED": "Evenement en echec rejoue",
      "INVOICE_PDP_PA_REVIEW_RECOVERED": "Revue PDP/PA de la facture recuperee",
      "INVOICE_PDP_SUBMISSION_REVIEW_RECOVERED": "Revue de soumission PDP de la facture recuperee",
      "NOTIFICATION_DELIVERY_SWITCHED": "Canal de livraison des notifications change",
      "LIVE_HLS_DELAY_SET": "Delai HLS du Live defini",
      "LIVE_HLS_DELAY_CLEARED": "Delai HLS du Live supprime",
      "LIVE_WEBRTC_GLOBAL_MODE_SET": "Mode WebRTC global du Live defini",
      "LIVE_STREAMING_URLS_SET": "URLs de streaming du Live definies",
      "LIVE_VIEWER_WEBRTC_SET": "WebRTC du spectateur du Live defini",
      "LIVE_STREAMING_URLS_SYNCED": "URLs de streaming du Live synchronisees",
      "ORCHESTRATOR_JOB_RETRIED": "Job de l'orchestrateur relance",
      "ORCHESTRATOR_NODE_DELETED": "Noeud de l'orchestrateur supprime",
      "TCG_GAME_CREATED": "Jeu TCG cree",
      "TCG_GAME_TOGGLED": "Jeu TCG active ou desactive",
      "TCG_INGESTION_TRIGGERED": "Ingestion TCG lancee",
      "SHIPPING_RATES_SYNCED": "Tarifs d'expedition synchronises",
      "STRIPE_CONNECT_SYNCED": "Stripe Connect synchronise",
      "SELLER_REQUEST_STRIPE_CONNECT_SET": "Compte Stripe Connect associe a la demande vendeur",
      "DISCORD_ACCOUNT_FORCE_UNLINKED": "Compte Discord déconnecté par l'équipe",
      "DISCORD_TICKET_ERASED_EARLY": "Ticket Discord supprimé définitivement"
    },
    "targetLabels": {
      "SELLER_REQUEST": "Demande vendeur",
      "SHOP": "Boutique",
      "ORDER": "Commande",
      "REFERRAL_CAMPAIGN": "Campagne de parrainage",
      "USER": "Utilisateur",
      "COMMENT": "Commentaire",
      "RECONCILIATION": "Reconciliation",
      "LIVE_TERMINAL_EVENT": "Evenement terminal du Live",
      "CATEGORY": "Categorie",
      "WEIGHT": "Poids",
      "CONDITION": "Etat",
      "MESSAGE": "Message",
      "DISCOUNT": "Remise",
      "SEARCH": "Recherche",
      "ITEM": "Item",
      "REVIEW": "Avis",
      "LIVE": "Live",
      "LIVE_MESSAGE": "Message du Live",
      "SELLER_DEBT": "Dette vendeur",
      "DELIVERY_CARRIER": "Transporteur",
      "REPORT": "Signalement",
      "BUYER_STRIKE": "Strike acheteur",
      "SUPPORT_TICKET": "Ticket support",
      "PAYMENT": "Paiement",
      "PRODUCT_REQUEST": "Demande de produit",
      "QUEUE": "File d'attente",
      "DEAD_LETTER_JOB": "Job en dead letter",
      "FAILED_EVENT": "Evenement en echec",
      "INVOICE": "Facture",
      "PLATFORM": "Plateforme",
      "STRIPE_CONNECT_ACCOUNT": "Compte Stripe Connect",
      "ORCHESTRATOR_JOB": "Job de l'orchestrateur",
      "ORCHESTRATOR_NODE": "Noeud de l'orchestrateur",
      "TCG_GAME": "Jeu TCG"
    }
  },
  "launchStatus": {
    "title": "Statut de lancement",
    "description": "Vue d'ensemble go/no-go pour le jour du lancement.",
    "refresh": "Rafraichir",
    "refreshing": "Rafraichissement",
    "stale": "Donnees perimees",
    "loadFailed": "Echec du chargement du statut de lancement.",
    "info": "Info",
    "comingSoon": "a venir",
    "noQueues": "Aucune file remontee.",
    "overall": {
      "GO": "GO",
      "GOHint": "Tous les systemes sont nominaux.",
      "WARN": "WARN",
      "WARNHint": "Signaux degrades -- a surveiller.",
      "NOGO": "NO-GO",
      "NOGOHint": "Signaux critiques -- ne pas lancer."
    },
    "status": {
      "ok": "OK",
      "warn": "Avertissement",
      "crit": "Critique"
    },
    "signals": {
      "errors5xx": "Erreurs 5xx",
      "serviceUnavailable": "Réponses 503 (surcharge)",
      "liveTotalChanged": "Achats refusés (total modifié)",
      "wsAuthority": "Vérification des connexions au direct",
      "dbPool": "Pool de connexions DB",
      "queues": "Files d'attente",
      "stuckPayouts": "Payouts bloques",
      "payments": "Paiements",
      "walletDrift": "Ecart wallet",
      "p95Latency": "Latence p95",
      "liveViewers": "Viewers live"
    },
    "metric": {
      "count": "Nombre",
      "window": "Fenetre",
      "waiting": "En attente",
      "total": "Total",
      "idle": "Inactif",
      "succeeded": "Reussis",
      "failed": "Echoues",
      "value": "Valeur",
      "refused": "Refusés",
      "accepted": "Acceptées",
      "livesAtRisk": "Lives à risque",
      "degradedAdmissions": "Admises sans contrôle complet",
      "missingVerdictRefusals": "Clients du site refusés",
      "doubleOutageRefusals": "Refus (base et cache)",
      "redisChecksDeferred": "Contrôles repoussés (cache)",
      "checksPostponed": "Contrôles en retard",
      "pendingSqlVerifications": "En attente de contrôle",
      "outboxLag": "Retard des déconnexions"
    },
    "hints": {
      "serviceUnavailable": "Le site refuse du trafic pour se protéger (surcharge, base de données ou cache saturés) ou parce qu'un service externe (paiement, livraison, vidéo) ne répond plus. Les acheteurs voient un prix indisponible.",
      "liveTotalChanged": "Des acheteurs sont refusés parce que le total affiché ne correspond plus à celui du serveur. Une part élevée de refus empêche d'acheter.",
      "wsAuthority": "Quand la base de données ou le cache de sécurité ne répondent pas, les connexions au direct sont vérifiées avec moins de garanties. Un compte banni peut alors rester dans le direct."
    },
    "relative": {
      "justNow": "a l'instant",
      "seconds": "il y a {{n}} s",
      "minutes": "il y a {{n}} min",
      "hours": "il y a {{n}} h",
      "days": "il y a {{n}} j"
    }
  },
  "system": {
    "title": "Sante systeme",
    "heartbeats": "Heartbeats systeme",
    "noHeartbeats": "Aucune donnee de heartbeat disponible.",
    "state": {
      "OK": "OK",
      "DEGRADED": "Dégradé",
      "ERROR": "Erreur",
      "LATE": "En retard"
    },
    "hint": {
      "DEGRADED": "Le travail tourne mais un élément n'avance pas. Voir le détail ci-dessous, les alertes et le runbook.",
      "ERROR": "Le dernier passage a échoué. Voir les journaux de l'API et les alertes.",
      "LATE": "Le passage attendu n'a pas eu lieu : le travail ne tourne probablement plus. Voir les journaux de l'API et les alertes."
    },
    "lastPass": {
      "OK": "Son dernier passage s'était bien terminé.",
      "DEGRADED": "Son dernier passage était dégradé : un élément n'avançait pas.",
      "ERROR": "Son dernier passage avait échoué."
    },
    "jobs": {
      "discord-ticket-sync": "Pont Discord : lecture des fils",
      "discord-ticket-retention": "Pont Discord : rétention des fils",
      "discord-live-announce": "Annonces de Live Discord : passe quotidienne",
      "discord-role-sync": "Rôles Discord : passe quotidienne",
      "support-ticket-inactivity": "Support : clôture automatique",
      "support-ticket-retention": "Support : rétention des tickets"
    },
    "metadata": {
      "polled": "Fils relus",
      "imported": "Messages importés",
      "delivered": "Réponses postées",
      "refused": "Réponses refusées",
      "failed": "En échec",
      "refreshFailed": "Aperçus et réactions en échec",
      "budgetExhausted": "Budget du cycle épuisé",
      "skipped": "Passage sauté",
      "examined": "Tickets examinés",
      "reminded": "Rappels",
      "closed": "Tickets clos",
      "emailSkipped": "Email non balayé",
      "discordSkipped": "Discord non balayé",
      "erased": "Tickets effacés",
      "alreadyErased": "Déjà effacés",
      "deferred": "Reportés",
      "moreExpired": "Reste à effacer",
      "stuck": "Bloqués"
    },
    "metadataValue": {
      "BRIDGE_STOPPED": "arrêt de sécurité du pont, plus aucun appel vers Discord"
    },
    "lastRun": "Derniere execution",
    "nextExpected": "Prochaine execution prevue :",
    "incidents": "Incidents de sweep",
    "noIncidents": "Aucun incident enregistre -- le filet de securite n'a pas eu besoin d'intervenir.",
    "incidentDate": "Date",
    "incidentType": "Type",
    "incidentItems": "Articles traites",
    "incidentErrors": "Erreurs",
    "incidentDuration": "Duree",
    "incidentItemIds": "IDs articles",
    "loadMore": "Charger plus",
    "showLess": "voir moins",
    "more": "de plus"
  },
  "nodes": {
    "title": "Noeuds",
    "detail": "Detail du noeud",
    "refresh": "Actualiser",
    "nodeInfo": "Informations du noeud",
    "statusLabel": "Statut",
    "ip": "Adresse IP",
    "serverType": "Type de serveur",
    "hetznerId": "ID Hetzner",
    "dnsRecordId": "ID enregistrement DNS",
    "billingHourStart": "Debut heure de facturation",
    "createdAt": "Cree le",
    "destroyedAt": "Detruit le",
    "lives": "Lives sur ce noeud",
    "noLives": "Aucun live n'a ete assigne a ce noeud.",
    "eventLog": "Journal d'evenements",
    "noEvents": "Aucun evenement enregistre pour ce noeud.",
    "metadata": "Metadonnees",
    "hetznerActions": "Actions serveur Hetzner",
    "noHetznerActions": "Aucune action Hetzner disponible (le serveur a peut-etre ete supprime).",
    "deleteConfirmTitle": "Supprimer le noeud",
    "deleteConfirmMessage": "Etes-vous sur de vouloir supprimer le noeud \"{{id}}\" ? Cela terminera l'instance serveur.",
    "deleteSuccess": "Noeud supprime",
    "deleteFailed": "Impossible de supprimer le noeud",
    "loadFailed": "Impossible de charger les donnees du noeud"
  },
  "confirmDialog": {
    "title": "Confirmer l'action",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "reasonLabel": "Raison",
    "reasonPlaceholder": "Expliquez la raison de cette action (minimum 10 caracteres)...",
    "reasonMinLength": "Minimum {{min}} caracteres requis"
  },
  "infra": {
    "refresh": "Actualiser",
    "loadFailed": "Impossible de charger les donnees d'infrastructure",
    "overview": {
      "title": "Vue d'ensemble Infrastructure",
      "health": "Etat de sante",
      "uptime": "Temps de fonctionnement",
      "nodes": "Noeuds",
      "lives": "Lives",
      "videos": "Videos",
      "queues": "Files d'attente",
      "noQueues": "Aucune donnee de file d'attente disponible.",
      "failedJobsAlert": "{{count}} job(s) en echec necessitent une attention.",
      "viewQueues": "Voir les files"
    },
    "lives": {
      "title": "Lives Orchestrateur",
      "detail": "Detail du Live",
      "liveInfo": "Informations du Live",
      "node": "Noeud assigne",
      "streaming": "URLs de Streaming",
      "egress": "IDs Egress",
      "thumbnail": "Miniature",
      "notFound": "Live introuvable",
      "showing": "Affichage de {{count}} sur {{total}} lives"
    },
    "nodes": {
      "title": "Noeuds Orchestrateur",
      "detail": "Detail du Noeud",
      "nodeInfo": "Informations du Noeud",
      "includeDestroyed": "Inclure les noeuds detruits",
      "eventLog": "Journal d'evenements",
      "noEvents": "Aucun evenement enregistre pour ce noeud.",
      "notFound": "Noeud introuvable"
    },
    "videos": {
      "title": "Videos Orchestrateur",
      "showing": "Affichage de {{count}} sur {{total}} videos"
    },
    "queues": {
      "title": "Files d'attente Orchestrateur",
      "viewFailed": "Voir les jobs en echec",
      "failedJobs": "Jobs en echec",
      "noFailedJobs": "Aucun job en echec dans cette file.",
      "retrySuccess": "Job relance avec succes",
      "retryFailed": "Echec de la relance du job"
    }
  },
  "emails": {
    "title": "Templates Email",
    "refresh": "Actualiser",
    "totalTemplates": "Total templates",
    "synced": "Synchronises",
    "missing": "Manquants",
    "noTemplates": "Aucun template email trouve.",
    "templateName": "Nom du template",
    "description": "Description",
    "brevoId": "ID Brevo",
    "brevoTemplateName": "Nom Brevo",
    "active": "Actif",
    "statusSynced": "Synchro",
    "statusMissing": "Manquant",
    "statusError": "Erreur",
    "actions": "Actions",
    "preview": "Apercu"
  },
  "tcgReference": {
    "gamesTitle": "Jeux TCG",
    "createGame": "Creer un jeu",
    "newGame": "Nouveau jeu",
    "noGames": "Aucun jeu configure.",
    "code": "Code",
    "nameEn": "Nom (EN)",
    "nameFr": "Nom (FR)",
    "position": "Position",
    "toggleGame": "Basculer le statut du jeu",
    "activate": "Activer",
    "deactivate": "Desactiver",
    "sync": "Synchroniser",
    "syncGame": "Lancer la synchronisation du jeu",
    "syncing": "Synchronisation en cours...",
    "viewDetails": "Voir le detail",
    "cards": "cartes",
    "setsTab": "Sets",
    "productsTab": "Produits",
    "language": "Langue",
    "cardInfo": "Informations de la carte",
    "cardName": "Nom de la carte",
    "number": "Numero",
    "rarity": "Rarete",
    "attributes": "Attributs",
    "ingestion": {
      "title": "Suivi de l'ingestion",
      "sources": "Sources",
      "recentRuns": "Executions recentes",
      "triggerSync": "Lancer une synchronisation",
      "selectSource": "Selectionner une source",
      "choosePlaceholder": "Choisir une source...",
      "trigger": "Lancer",
      "source": "Source",
      "startedAt": "Debut",
      "completedAt": "Fin",
      "created": "Crees",
      "updated": "Mis a jour",
      "errors": "Erreurs",
      "noRuns": "Aucune execution trouvee.",
      "autoRefresh": "Actualisation auto en cours..."
    },
    "runDetail": {
      "title": "Detail de l'execution",
      "progress": "Progression",
      "processedCards": "Cartes traitees",
      "totalCards": "Total de cartes",
      "elapsed": "Duree",
      "duration": "Duree",
      "results": "Resultats",
      "updated": "maj",
      "errorsTable": "Erreurs",
      "noErrors": "Aucune erreur",
      "cardName": "Nom de la carte",
      "setCode": "Code du set",
      "errorMessage": "Message d'erreur",
      "runningFor": "En cours depuis",
      "syncCompleted": "Synchronisation terminee avec succes",
      "syncFailed": "Echec de la synchronisation"
    }
  },
  "settings": {
    "title": "Reglages",
    "appearance": {
      "sectionTitle": "Apparence",
      "light": "Clair",
      "lightDescription": "Theme clair, fond blanc",
      "dark": "Sombre",
      "darkDescription": "Theme sombre, mieux pour les yeux le soir",
      "system": "Systeme",
      "systemDescription": "Suit le reglage de votre systeme d'exploitation"
    },
    "language": {
      "sectionTitle": "Langue",
      "fr": "Francais",
      "en": "Anglais"
    },
    "discord": {
      "sectionTitle": "Compte Discord",
      "intro": "Connectez votre compte Discord pour que votre prénom apparaisse, à la place de votre pseudo Discord, quand vous écrivez directement dans un fil de demande.",
      "status": {
        "linked": "Connecté",
        "notLinked": "Non connecté"
      },
      "account": "Compte Discord",
      "linkedAt": "Connecté le",
      "link": "Connecter mon compte Discord",
      "redirecting": "Redirection vers Discord…",
      "redirectHint": "Vous allez être redirigé vers Discord pour autoriser Blisterr, puis vous reviendrez ici pour confirmer.",
      "unlink": "Déconnecter mon compte Discord",
      "unlinkTitle": "Déconnecter votre compte Discord ?",
      "unlinkBody": "Vos messages écrits directement dans un fil de demande ne porteront plus votre prénom, mais votre pseudo Discord. Si vous êtes aussi vendeur ou acheteur, vos rôles Marchand ✓ et Looteur ✓ seront retirés du serveur. Vous pourrez reconnecter votre compte Discord quand vous le souhaitez.",
      "unlinkConfirm": "Déconnecter Discord",
      "unlinked": "Votre compte Discord est déconnecté.",
      "linked": "Votre compte Discord est connecté.",
      "loadError": "Impossible de charger l'état de la connexion de votre compte Discord.",
      "callback": {
        "title": "Connexion de votre compte Discord",
        "loading": {
          "title": "Vérification en cours",
          "body": "Nous vérifions votre autorisation auprès de Discord. Ne fermez pas cette page."
        },
        "confirm": {
          "title": "Connecter @{{username}} ?",
          "account": "Compte Discord",
          "body": "Ce compte Discord sera connecté à votre compte Blisterr. Vous pourrez le déconnecter à tout moment.",
          "effect": "Votre prénom remplacera votre pseudo Discord sur les messages que vous écrivez directement dans un fil de demande.",
          "roles": "Si votre compte est aussi vendeur ou acheteur, vous recevrez les rôles Marchand ✓ et Looteur ✓, visibles de tous les membres du serveur. Vous pourrez les masquer à tout moment depuis l'application web de Blisterr (Paramètres, Comptes connectés).",
          "wrongAccount": "Ce n'est pas votre compte ? Annulez, fermez votre session Discord dans ce navigateur, rouvrez-la avec le bon compte, puis recommencez.",
          "accept": "Connecter @{{username}}",
          "cancel": "Annuler",
          "validity": "Cette confirmation est valable 5 minutes."
        },
        "errorTitle": "La connexion de votre compte Discord n'a pas abouti",
        "retry": "Recommencer",
        "back": "Retour aux réglages"
      },
      "error": {
        "denied": "Vous avez refusé l'autorisation sur Discord. Rien n'a été connecté.",
        "alreadyLinked": "Ce compte Discord est déjà connecté à un autre compte Blisterr. Rien n'a été connecté.",
        "alreadyHasLink": "Un compte Discord est déjà connecté à votre compte. Déconnectez-le d'abord.",
        "invalid": "Le lien n'est plus valable : il a expiré ou a déjà été utilisé. Rien n'a été connecté.",
        "stagingExpired": "La confirmation a expiré. Recommencez la connexion de votre compte Discord.",
        "unlinkInProgress": "La déconnexion de votre compte Discord est en cours. Réessayez dans quelques minutes.",
        "blocked": "La connexion d'un compte Discord est suspendue sur votre compte. Réessayez plus tard ou contactez un autre administrateur.",
        "oauthRejected": "La connexion à Discord est indisponible pour le moment : l'application Discord de Blisterr est refusée (alerte émise). Rien n'a été connecté.",
        "confirmInProgress": "Cette confirmation est déjà en cours de traitement. Revenez aux réglages pour voir l'état de la connexion de votre compte Discord.",
        "notLinked": "Votre compte Discord n'est plus connecté.",
        "rateLimited": "Trop de tentatives. Veuillez patienter quelques minutes avant de recommencer.",
        "unavailable": "La connexion à Discord est momentanément indisponible. Réessayez dans quelques minutes.",
        "unknown": "Une erreur est survenue. Veuillez réessayer."
      }
    }
  },
  "support": {
    "title": "Support",
    "detail": "Detail du ticket",
    "requester": "Demandeur",
    "email": "Email",
    "createdAt": "Cree le",
    "lastMessageAt": "Dernier message",
    "conversation": "Conversation",
    "noMessages": "Aucun message",
    "authorCustomer": "Client",
    "authorAdmin": "Support",
    "authorSystem": "Systeme",
    "replyTitle": "Repondre",
    "replyPlaceholder": "Saisissez votre reponse au client...",
    "send": "Envoyer",
    "close": "Fermer le ticket",
    "reopen": "Rouvrir le ticket",
    "filterAll": "Tous",
    "filterOpen": "Ouverts",
    "filterPending": "En attente",
    "filterClosed": "Fermes",
    "replySuccess": "Reponse envoyee au client",
    "closeSuccess": "Ticket ferme",
    "reopenSuccess": "Ticket rouvert",
    "replyQueued": "Réponse enregistrée : elle sera postée dans le fil Discord dans quelques secondes",
    "replyChannelUnavailable": "Réponse non envoyée : le fil Discord de ce ticket est indisponible.",
    "filterStatus": "Statut",
    "filterChannel": "Canal",
    "channelEmail": "Email",
    "channelDiscord": "Discord",
    "discordNickname": "Pseudo Discord",
    "authorTeamChannel": "équipe (Discord)",
    "composer": {
      "counter": "{{count}} / {{max}} caractères",
      "nearLimit": "Vous approchez de la limite de {{max}} caractères.",
      "overLimit": "Limite de {{max}} caractères dépassée : raccourcissez la réponse.",
      "disabled": "Réponse impossible : le fil Discord est indisponible."
    },
    "delivery": {
      "sending": "Envoi dans Discord en cours…",
      "pending": "Non remise dans Discord, nouvel essai au prochain cycle",
      "pendingClosed": "Non remis dans Discord (ticket clos, aucun nouvel essai)",
      "refused": {
        "BLOCKED_BY_MODERATION": "Refusée par Discord : bloquée par la modération du serveur (AutoMod)",
        "FORBIDDEN": "Refusée par Discord : droits manquants pour le bot sur ce fil",
        "INVALID": "Refusée par Discord : contenu invalide",
        "CHANNEL_UNAVAILABLE": "Non remise : le fil Discord est indisponible, cette réponse ne partira pas",
        "UNKNOWN": "Refusée par Discord"
      }
    },
    "attachment": {
      "download": "Télécharger : {{name}} ({{size}})",
      "newTab": "(s'ouvre dans un nouvel onglet)",
      "noPreview": "Aperçu indisponible pour ce format",
      "skipped": "Non conservée",
      "failed": "Copie impossible",
      "unavailable": "Fichier indisponible",
      "animation": "Animation en boucle",
      "reason": {
        "UNSUPPORTED_TYPE": "Seules les images sont conservées",
        "FILE_TOO_LARGE": "Fichier trop volumineux",
        "TOO_MANY_FILES": "Trop de fichiers dans le même message",
        "MESSAGE_QUOTA_EXCEEDED": "Quota de pièces jointes du message dépassé",
        "TICKET_QUOTA_EXCEEDED": "Quota de pièces jointes du ticket dépassé",
        "COPY_FAILED": "Copie impossible depuis Discord (lien expiré ou erreur réseau)"
      }
    },
    "reaction": {
      "label": "Réactions",
      "team": "(équipe)",
      "member": "(membre)",
      "othersOne": "et {{count}} autre",
      "othersMany": "et {{count}} autres"
    },
    "notice": {
      "unverified": "Ce membre n'est pas vérifié. Ne communiquez aucune donnée de compte ni de commande ; ne modifiez rien depuis ce ticket.",
      "issueUnavailable": "Le fil Discord est indisponible : vos réponses ne peuvent plus partir.",
      "issueSetupFailed": "Le fil Discord de cette demande n'a pas pu être créé : vos réponses ne peuvent pas partir.",
      "issueAction": "Demandez au membre d'ouvrir une nouvelle demande depuis #aide (sur le serveur, jamais en message privé : l'équipe s'est engagée à ne pas en envoyer), puis clôturez ce ticket.",
      "issueClosed": "Le fil Discord de cette demande est indisponible. Le ticket étant clos, il n'y a rien à faire.",
      "verified": "Ce membre est vérifié : son compte Discord est connecté à son compte Blisterr ({{name}}). Vous pouvez lui communiquer l'état et le suivi de ses commandes. Ne communiquez ni adresse complète ni moyen de paiement, et ne modifiez aucune donnée de son compte depuis ce ticket.",
      "restricted": "Le compte Blisterr connecté à ce membre est {{status}}. Ne communiquez aucune donnée de compte ni de commande.",
      "recent": "Ce compte Discord a été connecté il y a moins de 72 heures. Redoublez de prudence.",
      "viewAccount": "Voir la fiche du compte",
      "nameFallback": "prénom non renseigné",
      "status": {
        "ACTIVE": "restreint",
        "SUSPENDED": "suspendu",
        "BANNED": "banni",
        "DELETED": "supprimé"
      }
    },
    "conflict": {
      "message": "Ce ticket a changé pendant votre action (autre admin, nouveau message ou ticket clos entre-temps). Votre action n'a pas été enregistrée.",
      "replyKept": "Le texte de votre réponse est conservé.",
      "reloadHint": "Rechargez le ticket pour voir son état actuel, puis recommencez.",
      "refreshedHint": "Le ticket vient d'être actualisé : relisez-le, puis recommencez.",
      "closedMessage": "Ce ticket a été clos pendant que vous rédigiez votre réponse. Elle n'a pas été envoyée.",
      "closedReloadHint": "Copiez votre texte si vous voulez le garder, rechargez le ticket, puis rouvrez-le au besoin pour répondre.",
      "closedRefreshedHint": "Le ticket vient d'être actualisé : rouvrez-le au besoin pour répondre.",
      "reload": "Recharger le ticket",
      "dismiss": "Fermer ce message"
    },
    "accountLine": "Compte Blisterr",
    "erase": {
      "action": "Effacer ce ticket",
      "title": "Effacer ce ticket Discord ?",
      "body": "Le fil Discord, les pièces jointes et le ticket seront supprimés définitivement. Indiquez le motif, il est conservé dans le journal des actions.",
      "confirm": "Effacer définitivement",
      "reasonPlaceholder": "Motif de l'effacement (3 à 200 caractères)…",
      "erased": "Ticket effacé.",
      "alreadyErased": "Ce ticket était déjà effacé.",
      "errors": {
        "notFound": "Ce ticket n'existe plus.",
        "wrongChannel": "Seul un ticket Discord s'efface ici. Un ticket e-mail s'efface par la commande support:erase-ticket.",
        "notClosed": "Ce ticket a été rouvert : il doit être clos pour être effacé. Il vient d'être actualisé.",
        "openingInProgress": "Le fil Discord de ce ticket est encore en cours d'ouverture. Réessayez dans quelques instants."
      }
    }
  },
  "errors": {
    "unknown": "Une erreur est survenue. Veuillez reessayer.",
    "forbidden": "Action interdite : vous n'avez pas les droits.",
    "notFound": "Element introuvable : il a peut-etre ete supprime.",
    "conflict": "Conflit : un autre admin a modifie cet element. Rechargez la page.",
    "validation": "Validation echouee. Verifiez les champs saisis.",
    "validationWithDetail": "Validation echouee : {{detail}}",
    "server": "Erreur serveur. L'equipe est notifiee."
  },
  "refunds": {
    "openButton": "Rembourser",
    "dialogTitle": "Rembourser la commande",
    "dialogSubtitle": "Le remboursement sera credite sur le wallet de l'acheteur.",
    "amountLabel": "Montant a rembourser",
    "amountHelper": "Maximum : {{max}}",
    "amountTooHigh": "Le montant ne peut depasser le total de la commande.",
    "amountTooLow": "Le montant doit etre superieur a 0.",
    "reasonLabel": "Motif",
    "reasonRequired": "Le motif est obligatoire.",
    "reason": {
      "litige_buyer": "Litige acheteur",
      "defective_item": "Article defectueux",
      "no_show_seller": "Vendeur absent / non envoye",
      "other": "Autre"
    },
    "noteLabel": "Note interne admin",
    "notePlaceholder": "Contexte interne, ID du ticket support, etc.",
    "includeShipping": "Inclure les frais de livraison dans le remboursement",
    "confirmTitle": "Confirmer le remboursement",
    "confirmSubtitle": "Vous etes sur le point de rembourser",
    "confirmIrreversible": "Cette action est irreversible. Le montant sera credite sur le wallet de l'acheteur.",
    "confirmButton": "Confirmer le remboursement",
    "back": "Retour",
    "submitting": "Remboursement en cours...",
    "success": "Remboursement effectue",
    "error": "Echec du remboursement",
    "unavailableNoPayment": "Remboursement indisponible : aucun paiement associé n'est exposé par l'API pour cette commande.",
    "shippingIncludedNote": "Frais de livraison inclus dans le remboursement",
    "errorIdempotencyReuse": "Une demande de remboursement différente a déjà utilisé cette clé. Rouvrez le dialogue pour réessayer.",
    "errorExceedsTotal": "Le montant dépasse le total remboursable du paiement.",
    "errorNotEligible": "Ce paiement n'est pas éligible au remboursement.",
    "errorLiveAttachedToActiveOrder": "Ce paiement live fait partie d'une commande en cours : annulez la commande pour le rembourser."
  },
  "reconciliationDiscrepancy": {
    "resolveButton": "Resoudre",
    "addNoteButton": "Ajouter une note",
    "dialogResolveTitle": "Resoudre l'ecart",
    "dialogResolveSubtitle": "Choisissez la source de verite et documentez la decision.",
    "resolutionLabel": "Resolution",
    "resolution": {
      "STRIPE_WINS": "Stripe a raison (corriger la DB)",
      "DB_WINS": "DB a raison (Stripe est obsolete)",
      "MANUAL_NOTE": "Note manuelle (aucune correction)"
    },
    "noteLabel": "Note",
    "notePlaceholder": "Contexte de la decision, lien vers le ticket...",
    "noteRequired": "La note est obligatoire.",
    "dialogNoteTitle": "Ajouter une note",
    "notesTitle": "Notes",
    "noNotes": "Aucune note pour le moment.",
    "addNote": "Ajouter",
    "submitting": "Enregistrement...",
    "resolveSuccess": "Ecart resolu",
    "noteAddedSuccess": "Note ajoutee",
    "addedBy": "par",
    "at": "le"
  },
  "liveMessages": {
    "unhide": {
      "notFound": "Message introuvable.",
      "notHidden": "Ce message n'est pas masque.",
      "failed": "Echec de la restauration du message"
    }
  },
  "reportNotes": {
    "saveButton": "Enregistrer la note",
    "saving": "Enregistrement...",
    "success": "Note enregistree",
    "noChange": "Aucun changement a enregistrer",
    "tooLong": "La note ne peut pas depasser 1000 caracteres."
  },
  "userWallet": {
    "title": "Wallet",
    "viewLink": "Voir le wallet",
    "balanceLabel": "Solde actuel",
    "withdrawableLabel": "Retirable",
    "nonWithdrawableLabel": "Non retirable",
    "creditButton": "Crediter manuellement",
    "back": "Retour",
    "submitting": "Credit en cours...",
    "creditDialogTitle": "Crediter le wallet",
    "creditDialogSubtitle": "Cette action deplace de l'argent et est logguee dans l'audit admin.",
    "amountLabel": "Montant a crediter",
    "amountHelper": "En euros (2 decimales max), max {{max}} €",
    "amountTooLow": "Le montant doit etre d'au moins 0,01 €.",
    "amountTooHigh": "Le montant ne peut pas depasser {{max}} €.",
    "reasonLabel": "Motif",
    "reason": {
      "COMMERCIAL_GESTURE": "Geste commercial",
      "SUPPORT_CORRECTION": "Correction support",
      "OTHER": "Autre"
    },
    "noteLabel": "Note interne",
    "noteHelper": "Obligatoire, au moins {{min}} caracteres.",
    "noteTooShort": "La note doit faire au moins {{min}} caracteres.",
    "notePlaceholder": "Lien ticket support, contexte...",
    "confirmSubtitle": "Vous allez crediter le wallet de cet utilisateur de :",
    "confirmIrreversible": "Ce credit est applique immediatement et ne peut pas etre annule.",
    "creditSuccess": "Wallet credite",
    "creditError": "Echec du credit",
    "errorLimitExceeded": "Le montant depasse le plafond de credit autorise.",
    "errorIdempotencyReuse": "Ce credit a deja ete soumis avec des valeurs differentes.",
    "transactionsTitle": "Derniers mouvements",
    "noTransactions": "Aucune transaction.",
    "loadError": "Impossible de charger le wallet.",
    "txnType": "Type",
    "txnAmount": "Montant",
    "txnBalanceAfter": "Solde apres",
    "txnDescription": "Description",
    "txnDate": "Date",
    "txnOrderLink": "Voir la commande",
    "txnPayment": "Référence de paiement :",
    "txnPaymentMissing": "Aucun paiement enregistré pour cette référence. La commande ne peut pas être identifiée depuis cette écriture.",
    "txnNoOrder": "Paiement enregistré, sans commande directement liée. Un achat live peut être regroupé dans une commande plus tard.",
    "transactionTypes": {
      "CREDIT_PLATFORM_FEES": "Frais plateforme crédités",
      "DEBIT_PLATFORM_REFUND": "Frais plateforme remboursés"
    }
  },
  "missingInvoices": {
    "title": "Factures manquantes",
    "intro": "Commandes dont une facture legale attendue n'a jamais ete generee (echec silencieux). Relancez la generation, ou corrigez la donnee vendeur si l'echec est permanent.",
    "colOrder": "Commande",
    "colConfirmedAt": "Confirmee le",
    "colMissingTypes": "Factures manquantes",
    "colParticipants": "Boutique / Acheteur",
    "shop": "Boutique",
    "buyer": "Acheteur",
    "retry": "Relancer",
    "retrying": "Relance...",
    "retrySuccess": "{{count}} facture(s) generee(s)",
    "retryFailed": "{{count}} facture(s) en echec - verifiez la donnee vendeur",
    "retryNone": "Aucune facture generee",
    "empty": "Aucune facture manquante",
    "emptyHint": "Toutes les factures legales attendues ont ete generees.",
    "loadError": "Echec du chargement des factures manquantes."
  },
  "finance": {
    "unavailable": "Indisponible",
    "title": "Vue d’ensemble",
    "refresh": "Actualiser",
    "error": "Impossible de charger les finances. Aucun montant ne peut être confirmé.",
    "missingWallet": "Wallet plateforme introuvable. Le solde est indisponible.",
    "balance": "Solde du wallet interne",
    "gross": "Frais crédités cumulés",
    "reversed": "Frais repris (remboursements)",
    "net": "Frais nets enregistrés",
    "today": "Frais nets du jour",
    "explanation": "Frais nets = frais crédités − frais repris, tous statuts de commande confondus. Livraison incluse : ce montant ne représente ni le bénéfice, ni le solde Stripe. Le solde du wallet inclut aussi ses autres mouvements.",
    "walletSection": "Solde interne",
    "walletHint": "Tous les mouvements du wallet inclus.",
    "feesSection": "Écritures de frais",
    "feesHint": "Montants issus des mouvements du wallet, avant vérification des paiements liés.",
    "reviewSection": "Points à vérifier",
    "reviewHint": "Montants déjà inclus ci-dessus ou restant à créditer, à rapprocher des paiements.",
    "history": "Voir les écritures du wallet",
    "pending": "Crédits en traitement",
    "failed": "Crédits en échec",
    "missingCredits": "Frais restant à créditer",
    "orphanCredits": "Crédits sans paiement associé",
    "orphanExplanation": "Ces crédits sont inclus dans les montants affichés, mais leur paiement associé est absent. À vérifier avant toute interprétation des revenus.",
    "netHint": "Frais crédités moins les frais repris.",
    "todayHint": "Depuis minuit, heure serveur.",
    "scopeHint": "Livraison incluse · Ni bénéfice, ni solde Stripe.",
    "calculationDetails": "Comprendre le calcul des frais",
    "entry": "Écriture",
    "count": "Nombre",
    "amount": "Montant"
  },
  "integrity": {
    "showDetails": "Voir les anomalies",
    "title": "Contrôle de cohérence",
    "explanation": "Rapprochement par paiement et remboursement, au centime, avec les écritures et le solde. Un déficit récent reste en traitement pendant 5 minutes. Le contrôle automatique est prévu toutes les 5 minutes.",
    "error": "Contrôle indisponible : la cohérence financière ne peut pas être confirmée.",
    "status": {
      "OK": "Aucun écart détecté",
      "PENDING": "Opérations en cours de traitement",
      "CRITICAL": "Écart financier détecté — investigation requise"
    },
    "checkedAt": "Vérifié le",
    "issues": "Anomalies",
    "pending": "Opérations en traitement",
    "action": "Vérifier les opérations concernées avant toute régularisation. Aucun solde n’est corrigé automatiquement.",
    "sample": "Échantillon de 100 anomalies maximum, réparties entre les catégories. Le compteur inclut toutes les anomalies ; plusieurs peuvent concerner la même opération.",
    "kind": "Contrôle",
    "reference": "Référence",
    "expected": "Attendu",
    "actual": "Constaté",
    "delta": "Écart",
    "kinds": {
      "CREDIT_MISMATCH": "Frais crédités incorrects",
      "REFUND_MISMATCH": "Frais remboursés incorrects",
      "ORPHAN_CREDIT": "Crédit sans paiement capturé",
      "ORPHAN_REVERSAL": "Débit sans remboursement terminé",
      "BALANCE_MISMATCH": "Solde différent des écritures",
      "MOVEMENT_MISMATCH": "Mouvement incohérent",
      "WALLET_MISSING": "Wallet absent",
      "WRONG_WALLET": "Frais sur un autre wallet",
      "FEE_RECORD_MISMATCH": "Registre des frais incohérent",
      "FEE_RECORD_REVERSAL_MISMATCH": "Registre des reprises incohérent",
      "ORPHAN_FEE_RECORD": "Frais sans écriture associée",
      "FEE_SOURCE_MISMATCH": "Sources tarifaires contradictoires",
      "CURRENCY_MISMATCH": "Devise incohérente",
      "FEE_SOURCE_MISSING": "Source tarifaire absente",
      "DUPLICATE_CREDIT": "Plusieurs crédits pour un paiement",
      "PREPAID_FEE_REVIEW": "Prépaiement live : frais historiques à rapprocher"
    },
    "methodDetails": "Comment fonctionne ce contrôle ?"
  },
  "payments": {
    "title": "Paiements",
    "requiresAction": "En attente d'action",
    "declinedRetry": "Refusé, nouvelle tentative possible",
    "failure": {
      "generic_decline": "Refus générique de la banque",
      "insufficient_funds": "Fonds insuffisants",
      "card_declined": "Carte refusée",
      "expired_card": "Carte expirée",
      "incorrect_cvc": "Cryptogramme (CVC) incorrect",
      "processing_error": "Erreur de traitement",
      "lost_card": "Carte déclarée perdue",
      "stolen_card": "Carte déclarée volée",
      "payment_intent_authentication_failure": "Échec de l'authentification 3D Secure",
      "unknown": "Motif de refus inconnu"
    }
  }
}
